import axios from 'axios';

import UiElement from '../../../shared/ui-element/ui-element';
import notification from '../notification/notification';

import './developers-contact-form.scss';

class DevelopersContactForm extends UiElement {
  ui = {
    submit: '.js-send-contact-button',
    formError: '.js-form-error',
    form: '#developers-contact-form',
  };

  events = {
    'submit @rootElement': 'handleFormSubmit',
  };

  constructor({ onSuccess }) {
    super({ rootElement: '#developers-contact-form' });
    this.onSuccess = onSuccess;
  }

  onInit() {
    super.onInit();
    this.apiUrl = this.rootElement.action;
  }

  getContactData() {
    const {
      name: { value: name },
      company: { value: company },
      website: { value: website },
      email: { value: email },
    } = this.rootElement.elements;

    return {
      name,
      company,
      website,
      email,
    };
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.disableSubmitBtn();
    this.hideErrors();
    this.submit();
  }

  submit() {
    const data = this.getContactData();

    return axios.post(this.apiUrl, data)
      .then(this.onSuccessfulRequest)
      .catch(this.handleFormError)
      .finally(() => {
        this.enableSubmitBtn();
      });
  }

  handleFormError = ({ response }) => {
    const { data: { errors } } = response;

    errors.forEach((error) => {
      const errorMessage = error.detail || this.rootElement.dataset.defaultError;

      if (error.source && error.source.parameter) {
        this.showFieldError(error.source.parameter, errorMessage);
      } else {
        this.showFormError(errorMessage);
      }
    });
  };

  showFieldError(fieldName, errorText) {
    const field = this.rootElement.elements[fieldName];

    if (!field) {
      return;
    }

    field.nextElementSibling.textContent = errorText;
    field.classList.add('form-group__form-control_invalid');
  }

  showFormError(errorText) {
    this.ui.formError.textContent = errorText;
    this.ui.formError.classList.add('d-block');
  }

  hideErrors() {
    [].forEach.call(this.rootElement.elements, (field) => {
      field.classList.remove('form-group__form-control_invalid');
    });

    this.ui.formError.classList.remove('d-block');
  }

  disableSubmitBtn() {
    this.ui.submit.disabled = true;
  }

  enableSubmitBtn() {
    this.ui.submit.disabled = false;
  }

  onSuccessfulRequest = ({ data: responseData }) => {
    this.onSuccess();
    this.rootElement.reset();
    notification.success(responseData.data.label);
  };
}

export default DevelopersContactForm;
